import React from 'react';
import cns from 'classnames';
import { Container, Image, Row, Col } from 'react-bootstrap';

import styles from './footer.module.scss';
import { Link } from 'react-router-dom';
import SOCIAL_LINKS from 'helper/const/social-links';
import { OUR_SERVICES, QUICK_LINKS } from 'helper/const/footer';

function Footer() {
  return (
    <footer className={cns(styles.bgDarken, 'pt-5')}>
      <Container>
        <Row className="mb-5">
          <Col md={3}>
            <h5 className="text-white mb-4 font-s3">Quick Links</h5>
            {QUICK_LINKS.map((item, idx) => (
              <Link key={idx} to={item.path} className={styles.footerLink}>
                {item.name}
              </Link>
            ))}
          </Col>

          <Col md={3}>
            <h5 className="text-white mb-4 font-s3">Our Programs</h5>
            {OUR_SERVICES.map((item, idx) => (
              <Link key={idx} to={item.href} className={styles.footerLink}>
                {item.name}
              </Link>
            ))}
          </Col>
          <Col md={3}>
            <h5 className="text-white mb-4 font-s3">Contact us</h5>
            <a
              href="mailto:sales@cap60.com"
              className="text-white mb-3 d-block"
            >
              sales@cap60.com
            </a>
            <a href="tel: 8183861081" className="text-white mb-3 d-block">
              818.386.1081
            </a>
          </Col>
          <Col mb={3}>
            <h5 className="text-white mb-4 font-s3">Follow Us</h5>
            <div className="d-flex">
              {SOCIAL_LINKS.map((item, idx) => (
                <SocialLink
                  key={idx}
                  href={item.link}
                  className="mr-2 mt-1 d-block"
                >
                  <Image src={item.icon} alt={item.name} />
                </SocialLink>
              ))}
            </div>
          </Col>
        </Row>
      </Container>
      <div className={styles.copy}>
        Copyrights © 2021. All rights reserved to CAP60.
      </div>
    </footer>
  );
}

const SocialLink = ({ href, children, ...rest }) => (
  <a href={href} target="_blank" rel="noreferrer" {...rest}>
    {children}
  </a>
);

export default Footer;
